module.exports = __webpack_public_path__ + "img/67.048ca7ef.jpg";